module.exports = __webpack_public_path__ + "img/wake-logo.5b765c17.png";